import React from "react";
import { Checkbox } from "antd";
import { capitalize } from "lodash";

import FilterPanel from "../../../commonComponents/FilterPanel/FilterPanel";
import { EMAIL_STATUS_ENUMS, EMAIL_TYPE_ENUMS } from "../../../../constant/EmailConstant";

// One tab's body: a searchable checkbox list styled like the Activity Center's
// QuickFiltersContent, with a per-tab "Clear" once something is selected.
const CheckboxListContent = ({ options, selected, onToggle, search = "", onClear }) => {
  const filteredOptions = options.filter(([, label]) =>
    label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex flex-col px-3 py-2">
      {onClear && selected.length > 0 && (
        <div className="flex justify-end mb-1">
          <span className="text-sm font-normal text-twLinkColor cursor-pointer" onClick={onClear}>
            Clear
          </span>
        </div>
      )}
      {filteredOptions.map(([key, label]) => {
        const isChecked = selected.includes(key);
        return (
          <div
            key={key}
            className="flex items-center gap-2 py-2 px-1 rounded cursor-pointer hover:bg-gray-50"
            onClick={() => onToggle(key, !isChecked)}
          >
            <Checkbox checked={isChecked} />
            <span className="text-sm text-black-88">{capitalize(label)}</span>
          </div>
        );
      })}
    </div>
  );
};

const EmailFilter = ({
  selectedEmailTypes = [],
  selectedEmailStatuses = [],
  onEmailTypeChange,
  onEmailStatusChange,
  onClearEmailTypes,
  onClearEmailStatuses,
  onClearAll,
  onClose,
}) => {
  const categories = [
    {
      key: "emailType",
      label: "Email type",
      count: selectedEmailTypes.length,
      // Only a handful of types — no list worth searching.
      searchable: false,
      onClear: onClearEmailTypes,
      render: (search, onClear) => (
        <CheckboxListContent
          options={Object.entries(EMAIL_TYPE_ENUMS)}
          selected={selectedEmailTypes}
          onToggle={onEmailTypeChange}
          search={search}
          onClear={onClear}
        />
      ),
    },
    {
      key: "emailStatus",
      label: "Email status",
      count: selectedEmailStatuses.length,
      searchPlaceholder: "Search email statuses",
      onClear: onClearEmailStatuses,
      render: (search, onClear) => (
        <CheckboxListContent
          options={Object.entries(EMAIL_STATUS_ENUMS)}
          selected={selectedEmailStatuses}
          onToggle={onEmailStatusChange}
          search={search}
          onClear={onClear}
        />
      ),
    },
  ];

  return (
    <FilterPanel categories={categories} onClearAll={onClearAll} onClose={onClose} width={600} />
  );
};

export default EmailFilter;
